import retry from 'retry';


// 默认错误过滤器（可重写）
function defaultErrorFilter(error) {
    const retryAbleCodes = ['SERVER_ERROR', 'TIMEOUT', 'NETWORK_ERROR'];
    return retryAbleCodes.includes(error?.code) || retryAbleCodes.includes(error?.message);
}

// 自定义错误类型
class NonRetryAbleError extends Error {
    constructor(message, attempt) {
        super(`[Fatal] ${message} (Attempt: ${attempt})`);
        this.name = 'NonRetryAbleError';
    }
}

class MaxRetriesError extends Error {
    constructor(message, attempt) {
        super(`[MaxRetries] ${message} (Attempt: ${attempt})`);
        this.name = 'MaxRetriesError';
        this.attempt = attempt;
    }
}

/**
 * 封装支持指数退避的重试机制
 * @param {Function} asyncFn - 需要重试的异步函数（需返回Promise）
 * @param {Object} options - 重试配置选项
 * @param {number} [options.retries=3] - 最大重试次数
 * @param {number} [options.factor=2] - 退避因子（指数基数）
 * @param {number} [options.minTimeout=1000] - 最小重试间隔(ms)
 * @param {number} [options.maxTimeout=30000] - 最大重试间隔(ms)
 * @param {boolean} [options.randomize=true] - 是否添加随机抖动
 * @param {Function} [isRetryAbleError] - 判断错误是否可重试的函数
 * @returns {Promise} - 返回带重试逻辑的Promise
 */
function _withRetry(asyncFn, options = {}, isRetryAbleError = defaultErrorFilter) {
    const op = retry.operation({
        retries: options.retries ?? 3,
        factor: options.factor ?? 2,
        minTimeout: options.minTimeout ?? 1000,
        maxTimeout: options.maxTimeout ?? 30000,
        randomize: options.randomize ?? true
    });

    return new Promise((resolve, reject) => {
        // 核心重试执行逻辑
        op.attempt(async (currentAttempt) => {
            try {
                const result = await asyncFn();
                resolve(result);
            } catch (error) {
                // 不可重试错误立即终止
                if (!isRetryAbleError(error)) {
                    console.log(error.message)
                    op.stop();
                    reject(new NonRetryAbleError(error.message, currentAttempt));
                    return;
                }

                // 可重试错误记录日志并继续
                console.warn(`Attempt ${currentAttempt} failed: ${error.message}`);
                if (op.retry(error)) return;

                // 重试耗尽后包装错误信息
                reject(new MaxRetriesError(error.message, currentAttempt));
            }
        });
    });
}


export const withRetry = _withRetry;